import { render } from "./PlansList.vue?vue&type=template&id=5c31c44e"
const script = {}
script.render = render

export default script